<template>
   <indexheader v-if="$route.meta.indexheader"></indexheader>
  <headerTop  v-if="$route.meta.keepAlive" ></headerTop>
  <router-view :key="new Date().getTime()"></router-view>
  <footerbottom v-if="$route.meta.footerAlive" />
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
import headerTop from "./components/headerTop.vue";
import Footerbottom from "./components/footerbottom.vue";
import theListOf from "./components/theListOf.vue";
import projectDetails from "./components/projectDetails.vue";
import mylogin from "./components/mylogin.vue";
import newlist from "./components/newlist.vue";
import informationForDetails from "./components/informationForDetails.vue";
import registered from "./components/registered.vue";
import teachersPersonalCenter from "./components/teachersPersonalCenter.vue";
import shareRanking from "./components/shareRanking.vue";
import personalCenterChangePasswords from "./components/personalCenterChangePasswords.vue";
import myCollection from "./components/myCollection.vue";
import myComments from "./components/myComments.vue";
import myExperiment from "./components/myExperiment.vue";
import theExperimentalEvaluation from "./components/theExperimentalEvaluation.vue";
import forgotPassword from "./components/forgotPassword.vue";

import liaoningTraffic from "./components/liaoningTraffic.vue";
import indexheader from "./components/indexheader.vue";



export default {
  name: "App",

  components: {
    HelloWorld,
    headerTop,
    indexheader,
    Footerbottom,
    theListOf,
    projectDetails,
    mylogin,
    newlist,
    informationForDetails,
    registered,
    teachersPersonalCenter,
    shareRanking,
    personalCenterChangePasswords,
    myCollection,
    myComments,
    myExperiment,
    theExperimentalEvaluation,
    forgotPassword,

    liaoningTraffic,
  },

 
};
</script>

<style scope>

</style>